
import ImageBox from '../imageBox/index.jsx'
import EffectDisplay from '../effectDisplay/index.jsx'
import './side.less'
import { useState } from 'react'
import React from 'react'
console.log(React)
export default function TopRotationSide(props) {
  const [ifon] = useState({
    options: [{}, {}, {}, { id: 3, src: 'https://wxa.wxs.qq.com/images/yijie/placeholders/pyq-placeholder-regular-img-3.png' }, { id: 4, src: 'https://wxa.wxs.qq.com/images/yijie/placeholders/pyq-placeholder-regular-img-4.png' }, {}, { id: 6, src: 'https://wxa.wxs.qq.com/images/yijie/placeholders/pyq-placeholder-regular-img-6.png' }]
  })

  return (<div className='side'>
    <div className='side_no1'>
      <h3 className='no1_title'>顶部组件: 轮播图</h3>
      <div className='no1_box'>支持腾讯广告全广告位</div>
    </div>
    <div className='side_no2'>
      <p className='no2_p1'>适用广告位：朋友圈信息流</p>
      <p className='no2_p1'>适用外层样式：常规广告</p>
      <p className='no2_tips'>创建广告时，仅选择了以上广告位与外层样式的广告可使用此推广页。广告外层将自动拉取顶部轮播图。</p>
    </div>
    <div className='side_no3'>
      <h3 className='no3_title'>素材设置</h3>
      <div className='no3_box'>
        <span className='box_title'>图片数量</span>
        <div className='box_box'>
          <div className={`box_item ${props.ifon.image_id_list.length === 3 ? 'active' : ''}`} onClick={() => {
            if (props.ifon.image_id_list.length !== 3) {
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                image_id_list: props.ifon.image_id_list.slice(0, 3)
              })
            }
          }}>3张</div>
          <div className={`box_item ${props.ifon.image_id_list.length === 4 ? 'active' : ''}`} onClick={() => {
            if (props.ifon.image_id_list.length !== 4) {
              if (props.ifon.image_id_list.length < 4) {
                props.ifon.image_id_list.push({})
              } else {
                props.ifon.image_id_list.splice(4, props.ifon.image_id_list.length)
              }
              props.mySetIfon && props.mySetIfon({
                ...props.ifon
              })
            }
          }}>4张</div>
          <div className={`box_item ${props.ifon.image_id_list.length === 6 ? 'active' : ''}`} onClick={() => {
            if (props.ifon.image_id_list.length !== 6) {
              for (let i = props.ifon.image_id_list.length; i < 6; i++) {
                props.ifon.image_id_list.push({})
              }
              props.mySetIfon && props.mySetIfon({
                ...props.ifon
              })
            }
          }}>6张</div>
        </div>
      </div>
    </div>
    <div className='side_no4'>
      <h3 className='no4_title'>上传素材</h3>
      <div className='no4_box'>
        <ul className='box_box'>
          {props.ifon.image_id_list.map((item, index) => {
            return (<li className='box_item' key={index}><ImageBox src={item.path} change={() => {
              props.hoistPopup && props.hoistPopup(index)
            }} mySwitch={() => {
              props.hoistPopup && props.hoistPopup(index)
            }} imgClick={() => {
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                currentIndex: index
              })
            }} isActive={props.ifon.currentIndex === index && props.ifon.image_id_list[props.ifon.currentIndex].path}></ImageBox></li>)
          })}
        </ul>
      </div>
      <p className='no4_p1'>在投放广告时，此图会同步作为朋友圈外层图</p>
      <p className='no4_p2'>在投放广告时，此图会同步作为朋友圈外层图<br />文字占比：不超过30%<br />图片尺寸：800*800像素</p>
    </div>
    <EffectDisplay src={ifon.options[props.ifon.image_id_list.length].src}>查看广告位外层效果</EffectDisplay>
  </div>)
}
